import React from "react";

const CallToAction = () => {
    return (
      <section className="bg-blue-500 text-white py-20 px-4">
        <div className="max-w-4xl mx-auto text-center space-y-6">
          <h2 className="text-3xl md:text-4xl font-bold">Let’s Build Something Amazing Together</h2>
          <p className="text-lg md:text-xl text-white">
            Reach out now and start your digital journey with Digiscape.
            We’re just a message or call away!
          </p>
  
          {/* Contact Info */}
          <div className="space-y-2 text-lg">
            <p>📞 (416) 826-3733</p>
            <p>✉️ info@digiscapesolutions.com</p>
          </div>
  
          {/* Action Buttons */}
          <div className="flex flex-col sm:flex-row justify-center gap-4 pt-6">
            <a href="tel:4168263733" className="btn bg-base-100 text-base">
              Call Us
            </a>
            <a href="mailto:info@digiscapesolutions.com" className="btn btn-outline border-white text-base hover:bg-white hover:text-purple-600">
              Email Us
            </a>
          </div>
        </div>
      </section>
    );
  };
  
  export default CallToAction;
  